import { apiFetch } from './http';

/**
 * Settings API (full-live-cutover §3 — the Settings screen build).
 *
 * LLM BYO keys wire to the EXISTING L8 sealed-store route
 * (/api/llm/byo/keys): keys are sealed AES-256-GCM server-side (seal key is
 * host-env); the plaintext NEVER round-trips — the list endpoint returns
 * masked metadata only (provider, enabled, rotatedAt), so the UI renders
 * registration state, never key material.
 *
 * Key custody DECIDED 2026-09-21 (cutover §6, coordinator): tenant BYO keys
 * via this route; platform keys are host-env injection only and appear
 * NOWHERE in Settings. No profile/team/billing write APIs exist this batch —
 * the corresponding modules either read-only or labeled sample; do not
 * invent endpoints here.
 */

export const LLM_PROVIDERS = [
  { id: 'openrouter', label: 'OpenRouter', hint: 'Multi-model gateway' },
  { id: 'google', label: 'Google', hint: 'Gemini API key' },
  { id: 'z-ai', label: 'Z.ai', hint: 'GLM API key' },
  { id: 'deepseek', label: 'DeepSeek', hint: 'DeepSeek API key' },
  { id: 'anthropic', label: 'Anthropic', hint: 'Claude API key' },
  { id: 'openai', label: 'OpenAI', hint: 'OpenAI API key' },
  { id: 'custom', label: 'Custom', hint: 'Any OpenAI-compatible base URL + key' }
];

/** The session tenant's BYO registrations, MASKED (no key material —
 * provider/enabled/rotatedAt only). */
export function listByoKeys() {
  return apiFetch('/api/llm/byo/keys');
}

/** Register/replace the tenant key for a provider. The key is sent ONCE,
 * sealed server-side, and never readable again through the API. */
export function registerByoKey(provider, key) {
  return apiFetch('/api/llm/byo/keys', {
    method: 'POST',
    body: JSON.stringify({ provider, key })
  });
}

/** Revoke (disable) the tenant key for a provider — routing falls back to
 * the platform key on the next call. */
export function revokeByoKey(provider) {
  return apiFetch(`/api/llm/byo/keys/${encodeURIComponent(provider)}`, {
    method: 'DELETE'
  });
}
